import React from 'react';

export const titleCase = (str: string) => {
  return str.replace(/\b\w/g, char => char.toUpperCase());
}

// Renders an error message for Hbr form components
export const renderErrorMessage = (showError: boolean, message: string) => {
  if (showError) {
    return (
      <div slot="help-text" className='text-sm mt-2 text-danger'>
        {message}
      </div>
    );
  }
  return null;
};